import React from "react";
import SearchablePicker from "components/SearchablePicker.tsx";
import { ModelOption } from "../types.ts";

interface ModelPickerProps {
  label: string;
  modelOptions: ModelOption[];
  selectedModel: string;
  searchTerm: string;
  onModelSelect: (modelId: string) => void;
  onSearchTermChange: (term: string) => void;
  placeholder: string;
}

const ModelPicker: React.FC<ModelPickerProps> = ({
  label,
  modelOptions,
  selectedModel,
  searchTerm,
  onModelSelect,
  onSearchTermChange,
  placeholder,
}) => {
  const [showPicker, setShowPicker] = React.useState(!selectedModel);

  const handleClear = () => {
    onModelSelect("");
    setShowPicker(true);
  };

  const handleSelect = (modelId: string) => {
    onModelSelect(modelId);
    setShowPicker(false);
  };

  return (
    <div style={{ width: '100%' }}>
      {selectedModel && !showPicker ? (
        <div className="settings-page__config-value" style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          padding: '8px 12px',
          border: '1px solid #ddd',
          borderRadius: '4px',
          backgroundColor: '#f9f9f9'
        }}>
          <span>{selectedModel}</span>
          <button
            onClick={handleClear}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '16px',
              color: '#666',
              padding: '2px 6px',
              borderRadius: '3px',
              marginLeft: '8px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#e0e0e0';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            ✕
          </button>
        </div>
      ) : (
        <SearchablePicker<ModelOption>
          items={modelOptions}
          getKey={(m: ModelOption) => m.id}
          onSelect={(m: ModelOption) => {
            handleSelect(m.id);
          }}
          searchTerm={searchTerm}
          onSearchTermChange={onSearchTermChange}
          inputClassName="settings-page__input"
          listClassName="settings-page__picker-list"
          itemClassName="settings-page__picker-item"
          newItemClassName="settings-page__picker-new"
          filter={(item: ModelOption, term: string) =>
            item.label.toLowerCase().includes(term.toLowerCase()) ||
            item.id.toLowerCase().includes(term.toLowerCase())
          }
          sort={(a: ModelOption, b: ModelOption, term: string) => {
            const t = term.toLowerCase();
            const aStarts = a.label.toLowerCase().startsWith(t) ? 0 : 1;
            const bStarts = b.label.toLowerCase().startsWith(t) ? 0 : 1;
            if (aStarts !== bStarts) return aStarts - bStarts;
            return a.label.localeCompare(b.label);
          }}
          renderItem={(item: ModelOption) => (
            <div>
              <div>{item.label}</div>
              {item.id !== item.label && <small>{item.id}</small>}
            </div>
          )}
          showCreateNew
          onCreateNew={(term: string) => {
            handleSelect(term);
          }}
          createNewLabel={(term: string) => `Use custom model \"${term}\"`}
          placeholder={placeholder}
        />
      )}
    </div>
  );
};

export default ModelPicker;
